import { render, staticRenderFns } from "./AppWidgetWithCircle.vue?vue&type=template&id=0d8c7d8d"
import script from "./AppWidgetWithCircle.vue?vue&type=script&lang=js"
export * from "./AppWidgetWithCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports